module.exports = __webpack_public_path__ + "static/media/close_black.f3bae118.svg";